<template>
    <div class="wtd-certificates">
        <BaseBinanceIcon class="wtd-certificates__item"/>
        <BaseBtcTurkIcon class="wtd-certificates__item"/>
        <BaseCointrIcon class="wtd-certificates__item"/>
        <BaseBlackRockIcon class="wtd-certificates__item"/>
        <BaseCryptocomIcon class="wtd-certificates__item"/>
    </div>
</template>
<script>
import {mapGetters} from "vuex"
import BaseBinanceIcon from "@/new-design/shared/ui/Icons/BaseBinanceIcon.vue"
import BaseBtcTurkIcon from "@/new-design/shared/ui/Icons/BaseBtcTurkIcon.vue"
import BaseCointrIcon from "@/new-design/shared/ui/Icons/BaseCointrIcon.vue"
import BaseCryptocomIcon from "@/new-design/shared/ui/Icons/BaseCryptocomIcon.vue"
import BaseBlackRockIcon from "@/new-design/shared/ui/Icons/BaseBlackRockIcon.vue"

export default {
    name: "WithdrawalCertificates",
    components: {BaseBlackRockIcon, BaseCryptocomIcon, BaseCointrIcon, BaseBtcTurkIcon, BaseBinanceIcon},
    computed:{
        ...mapGetters(['staticBase'])
    }
}
</script>
<style scoped>
.wtd-certificates {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
}

@media (max-width: 1000px) {
    .wtd-certificates {
        margin-top: 10px;
        gap: 12px;
    }
}
</style>